import { ref, type Ref } from 'vue'
import { instance as getApi } from '@/helpers/api'
import { Mitteilung } from '@/models/Mitteilung'
import { createModel } from '@kp/js-model'

const messages: Ref<Mitteilung[]> = ref([])

export function useUnreadMessages(): Ref<Mitteilung[]> {
    return messages
}

export async function useUnreadMessagesCount(): Promise<number> {
    const cnt = messages.value.length
    return cnt
}

export async function updateUnreadMessages() {
    try {
        const data = await getApi().get('/mitteilung/getUnreadMessages')
        const res: Mitteilung[] = []
        data.data.records.forEach((r: Mitteilung) => res.push(createModel(Mitteilung, r)))
        messages.value = res
    } catch (e) {
        console.error(e)
    }
}
